import { render } from "./CaffeTatte.vue?vue&type=template&id=07ab3008"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CaffeTatte.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07ab3008"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07ab3008', __exports__)) {
    api.reload('07ab3008', __exports__)
  }
  
  module.hot.accept("./CaffeTatte.vue?vue&type=template&id=07ab3008", () => {
    api.rerender('07ab3008', render)
  })

}


export default __exports__